
export const containsAllRequiredFields = ({ requiredFields, object }) => {
    if (requiredFields.length > Object.keys(object).length) {
        return false;
    }

    const arrayLength = requiredFields.length;
    for (var i = 0; i < arrayLength; i++) {
        if (!object[requiredFields[i]]){
            return false;
        }
    }
    return true;
};